export default function (data) {

  let index = data.index

  let yAvgList = []
  let yAvgObj = data.value.y_avg

  for (let i in index) {
    yAvgList.push(yAvgObj[index[i]])
  }

  let yCountList = []
  let yCountObj = data.value.y_count

  for (let i in index) {
    yCountList.push(yCountObj[index[i]])
  }

  const dataCollection = {
    labels: index,
    datasets: [
      {
        data: yAvgList,
        yAxisID: 'yAvg',
        type: 'line',
        label: '予測',
        fill: false,
        lineTension: 0,
        backgroundColor: '#dca4ac',
        borderColor: '#dca4ac',
        pointBackgroundColor: '#d8243e',
        pointBorderColor: '#d8243e',
        pointHoverBackgroundColor: '#d8243e',
        pointHoverBorderColor: '#d8243e'
      },
      {
        data: yCountList,
        yAxisID: 'count',
        type: 'bar',
        label: '実績',
        backgroundColor: '#99aee2',
        borderColor: '#99aee2',
        pointBackgroundColor: '#2456d4',
        pointBorderColor: '#2456d4',
        pointHoverBackgroundColor: '#2456d4',
        pointHoverBorderColor: '#2456d4'
      }
    ]
  }

  const options = {
    responsive: true,
    title: {
      display: false
    },
    legend: {
      display: false
    },
    scales: {
      yAxes: [
        {
          id: 'count',
          position: 'left',
          scaleLabel: {
            display: true,
            labelString: '件数',
            fontSize: 16
          },
          ticks: {
            beginAtZero: false,
            major: {},
            minor: {}
          }
        },
        {
          id: 'yAvg',
          position: 'right',
          scaleLabel: {
            display: true,
            labelString: '発生率',
            fontSize: 16
          },
          gridLines: {
            drawOnChartArea: false
          },
          ticks: {
            beginAtZero: false,
            major: {},
            minor: {}
          }
        }
      ],
      xAxes: [
        {
          display: true,
          scaleLabel: {
            display: true,
            labelString: '予測確率',
            fontSize: 16
          }
        }
      ]
    }
  }

  return {
    type: 'bar',
    data: dataCollection,
    options: options
  }
}



// WEBPACK FOOTER //
// ./src/modules/chart/predictActual.js